// extracted by mini-css-extract-plugin
module.exports = {"progressBarSection":"FriendsInvitedProgress_progressBarSection__P2ySD","progressBar":"FriendsInvitedProgress_progressBar__LUeEN"};